const ToggleDensity = () => (
  <svg
    id="density"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 29.706 25.993"
  >
    <path
      id="Path_19"
      data-name="Path 19"
      d="M135.135,227h2.2v2.785h-2.2Z"
      transform="translate(-127.294 -215.686)"
      fill="inherit"
    />
    <path
      id="Path_20"
      data-name="Path 20"
      d="M203.067,227h2.2v2.785h-2.2Z"
      transform="translate(-191.285 -215.686)"
      fill="inherit"
    />
    <path
      id="Path_21"
      data-name="Path 21"
      d="M338.933,227h2.2v2.785h-2.2Z"
      transform="translate(-319.268 -215.686)"
      fill="inherit"
    />
    <path
      id="Path_22"
      data-name="Path 22"
      d="M406.865,227h2.2v2.785h-2.2Z"
      transform="translate(-383.259 -215.686)"
      fill="inherit"
    />
    <path
      id="Path_23"
      data-name="Path 23"
      d="M29.706,41.573V32H0v9.573Zm-4.638-7.427h1.849v1.741H25.069Zm0,3.72h1.849v1.741H25.069Zm-3.713-3.72H23.2v1.741H21.355Zm0,3.72H23.2v1.741H21.355Zm-3.713-3.72h1.849v1.741H17.642Zm0,3.72h1.849v1.741H17.642Zm-3.713-3.72h1.849v1.741H13.929Zm0,3.72h1.849v1.741H13.929Zm-3.713-3.72h1.849v1.741H10.215Zm0,3.72h1.849v1.741H10.215ZM6.5,34.147H8.351v1.741H6.5Zm0,3.72H8.351v1.741H6.5Zm-3.713-3.72H4.638v1.741H2.789Zm0,3.72H4.638v1.741H2.789Z"
      transform="translate(0 -32)"
      fill="inherit"
    />
    <path
      id="Path_24"
      data-name="Path 24"
      d="M474.8,227h2.159v2.785H474.8Z"
      transform="translate(-447.249 -215.686)"
      fill="inherit"
    />
    <path
      id="Path_25"
      data-name="Path 25"
      d="M67.2,227h2.2v2.785H67.2Z"
      transform="translate(-63.304 -215.686)"
      fill="inherit"
    />
    <path
      id="Path_26"
      data-name="Path 26"
      d="M0,227H2.159v2.785H0Z"
      transform="translate(0 -215.686)"
      fill="inherit"
    />
    <path
      id="Path_27"
      data-name="Path 27"
      d="M271,227h2.2v2.785H271Z"
      transform="translate(-255.276 -215.686)"
      fill="inherit"
    />
    <path
      id="Path_28"
      data-name="Path 28"
      d="M0,305v10.154H29.706V305Zm4.638,7.433H2.789v-1.741H4.638v1.741Zm0-3.72H2.789v-1.741H4.638v1.741Zm3.713,3.72H6.5v-1.741H8.351Zm0-3.72H6.5v-1.741H8.351Zm3.713,3.72H10.215v-1.741h1.849Zm0-3.72H10.215v-1.741h1.849Zm3.713,3.72H13.929v-1.741h1.849Zm0-3.72H13.929v-1.741h1.849Zm3.713,3.72H17.642v-1.741h1.849Zm0-3.72H17.642v-1.741h1.849Zm3.713,3.72H21.355v-1.741H23.2Zm0-3.72H21.355v-1.741H23.2Zm3.713,3.72H25.069v-1.741h1.849Zm0-3.72H25.069v-1.741h1.849Z"
      transform="translate(0 -289.16)"
      fill="inherit"
    />
  </svg>
);

export default ToggleDensity;
